

export const LAPTOP_MIN_WIDTH = 991;
export const LAPTOP_MIN_HEIGHT = 600;


export const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
export const getHeight = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

export const isLaptopDevice = (useState, useEffect) => {
    let [width, setWidth] = useState(getWidth());
    let [height, setHeight] = useState(getHeight());

    useEffect(() => {
        let timeoutId;
        const resizeListener = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setWidth(getWidth());
                setHeight(getHeight());
            }, 150);
        };
        window.addEventListener("resize", resizeListener);
        return () => {
            window.removeEventListener("resize", resizeListener);
        };
    }, []);
    return width > LAPTOP_MIN_WIDTH && LAPTOP_MIN_HEIGHT >= 550;
}